/* LA MARIE · Lupa de la ficha (21-oct-2026, Ola 1).
   Vista a pantalla completa con TODAS las fotos y videos del producto. Sin librerías.
   - Deslizar en celular (scroll-snap nativo), flechas, teclado (flechas, Inicio/Fin, Esc), botón cerrar.
   - Foco atrapado mientras está abierta y devuelto a quien la abrió; "atrás" del celular la cierra.
   - Tocar o hacer clic en una foto la amplía al doble y se recorre arrastrando; otro toque la devuelve.
   - Carga perezosa: solo pide la foto actual y sus vecinas, en el tamaño justo (srcset).
   Uso: LMLupa.open(items, indice, {returnFocus: elemento, origen: 'foto'|'boton'|'apiladas'})
   items: [{t:'i', s, ss, w, h, a} | {t:'v', p, s:[{u,m}], a} | {t:'e', u, p, a}] (los arma sections/lm-product.liquid). */
(function(){
  if(window.LMLupa)return;
  var CSS=''+
  '.lml{position:fixed;inset:0;z-index:2147483600;background:#F7F2EB;color:#241B12;display:flex;flex-direction:column;font-family:"Jost",sans-serif;-webkit-tap-highlight-color:transparent}'+
  '.lml[hidden]{display:none}'+
  '.lml-top{flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:8px 8px 8px 18px;min-height:64px}'+
  '.lml-n{font-size:15px;letter-spacing:.06em}'+
  '.lml-t{flex:1;min-width:0;font-family:"Cormorant Garamond",serif;font-size:20px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center}'+
  '.lml-b{width:48px;height:48px;flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid #E6DAC6;border-radius:50%;background:#fff;color:#241B12;cursor:pointer;transition:border-color .2s,opacity .2s}'+
  '.lml-b:hover{border-color:#241B12}'+
  '.lml-b:focus-visible{outline:2px solid #241B12;outline-offset:2px}'+
  '.lml-b[disabled]{opacity:.35;cursor:default;border-color:#E6DAC6}'+
  '.lml-b svg{width:20px;height:20px;display:block}'+
  '.lml-track{flex:1 1 auto;min-height:0;display:flex;margin:0;padding:0;list-style:none;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;overscroll-behavior:contain;scrollbar-width:none;-webkit-overflow-scrolling:touch}'+
  '.lml-track::-webkit-scrollbar{display:none}'+
  '.lml-s{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;display:flex;align-items:center;justify-content:center;padding:0 12px 12px;box-sizing:border-box;overflow:hidden;position:relative}'+
  '.lml-s img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;cursor:zoom-in;user-select:none;-webkit-user-drag:none}'+
  '.lml-s video,.lml-s iframe{display:block;max-width:100%;max-height:100%;width:100%;height:100%;border:0;background:#000;object-fit:contain}'+
  '.lml-s.z{overflow:auto;overscroll-behavior:contain;display:block;padding:0;touch-action:pan-x pan-y}'+
  '.lml-s.z img{max-width:none;max-height:none;cursor:zoom-out}'+
  '.lml-nav{position:absolute;top:50%;margin-top:-26px;z-index:2}'+
  '.lml-nav.lml-prev{left:16px}.lml-nav.lml-next{right:16px}'+
  '.lml-nav .lml-b{width:52px;height:52px}'+
  '.lml-ayuda{position:absolute;left:50%;bottom:14px;transform:translateX(-50%);font-size:13px;color:#6E5C47;background:rgba(247,242,235,.9);padding:4px 10px;border-radius:20px;pointer-events:none;white-space:nowrap}'+
  '@media (max-width:767px){.lml-top{min-height:60px}.lml-t{font-size:18px}.lml-s{padding:0 0 76px}.lml-nav{top:auto;bottom:14px;margin-top:0}.lml-nav.lml-prev{left:14px}.lml-nav.lml-next{right:14px}.lml-nav .lml-b{width:48px;height:48px}.lml-ayuda{bottom:28px}}'+
  '@media (prefers-reduced-motion:reduce){.lml-track{scroll-behavior:auto}}';

  var box,track,cnt,ttl,bx,bp,bn,ayuda,usoZoom=false,items=[],cur=0,ret=null,raf=0,abierta=false,estado=false,prevOv='',prevOvB='';
  var reduce=false;try{reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}

  function el(t,c,a){var e=document.createElement(t);if(c)e.className=c;if(a){for(var k in a){if(a.hasOwnProperty(k))e.setAttribute(k,a[k]);}}return e;}
  var IC={
    x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    p:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    n:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function build(){
    var st=el('style');st.textContent=CSS;document.head.appendChild(st);
    box=el('div','lml',{role:'dialog','aria-modal':'true','aria-label':'Fotos del producto',id:'lmlupa'});box.hidden=true;
    var top=el('div','lml-top');
    cnt=el('span','lml-n',{'aria-live':'polite'});
    ttl=el('span','lml-t',{'aria-hidden':'true'});
    bx=el('button','lml-b lml-x',{type:'button','aria-label':'Cerrar'});bx.innerHTML=IC.x;
    top.appendChild(cnt);top.appendChild(ttl);top.appendChild(bx);
    track=el('ul','lml-track');
    var wp=el('div','lml-nav lml-prev');bp=el('button','lml-b',{type:'button','aria-label':'Foto anterior'});bp.innerHTML=IC.p;wp.appendChild(bp);
    var wn=el('div','lml-nav lml-next');bn=el('button','lml-b',{type:'button','aria-label':'Foto siguiente'});bn.innerHTML=IC.n;wn.appendChild(bn);
    ayuda=el('span','lml-ayuda',{'aria-hidden':'true'});var tactil=false;try{tactil=window.matchMedia('(pointer: coarse)').matches;}catch(e){}ayuda.textContent=tactil?'Toca la foto para acercarla':'Haz clic en la foto para acercarla';
    box.appendChild(top);box.appendChild(track);box.appendChild(wp);box.appendChild(wn);box.appendChild(ayuda);
    document.body.appendChild(box);
    bx.addEventListener('click',function(){cerrar();});
    bp.addEventListener('click',function(){ir(cur-1,true);});
    bn.addEventListener('click',function(){ir(cur+1,true);});
    track.addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(leer);},{passive:true});
    track.addEventListener('click',function(e){var im=e.target.closest&&e.target.closest('.lml-s img');if(im)zoom(im,e);});
    window.addEventListener('resize',function(){if(!abierta)return;var s=track.children[cur];if(s&&s.classList.contains('z'))desZoom(s);track.scrollLeft=cur*track.clientWidth;});
    window.addEventListener('popstate',function(){if(abierta&&estado){estado=false;cerrar(true);}});
  }

  function pintar(){
    track.innerHTML='';
    for(var i=0;i<items.length;i++){
      var it=items[i]||{},li=el('li','lml-s',{role:'group','aria-roledescription':'foto','aria-label':(i+1)+' de '+items.length});
      if(it.t==='i'){var im=el('img',null,{alt:it.a||'',draggable:'false',decoding:'async'});if(it.w&&it.h){im.setAttribute('width',it.w);im.setAttribute('height',it.h);}li.appendChild(im);}
      li.setAttribute('data-i',i);track.appendChild(li);
    }
  }

  function cargar(i){
    var li=track.children[i];if(!li||li.getAttribute('data-ok'))return;li.setAttribute('data-ok','1');
    var it=items[i]||{};
    if(it.t==='i'){var im=li.querySelector('img');if(it.ss){im.setAttribute('sizes','100vw');im.setAttribute('srcset',it.ss);}im.setAttribute('src',it.s||'');}
    else if(it.t==='v'){var v=el('video',null,{controls:'',playsinline:'',preload:'metadata','aria-label':it.a||'Video del producto'});if(it.p)v.setAttribute('poster',it.p);(it.s||[]).forEach(function(s){v.appendChild(el('source',null,{src:s.u,type:s.m}));});li.appendChild(v);}
    else if(it.t==='e'){var f=el('iframe',null,{src:it.u||'',title:it.a||'Video del producto',allow:'autoplay; encrypted-media; picture-in-picture',allowfullscreen:'',loading:'lazy'});li.appendChild(f);}
  }

  function pausar(excepto){var vs=track.querySelectorAll('video');for(var k=0;k<vs.length;k++){var li=vs[k].parentNode;if(+li.getAttribute('data-i')!==excepto){try{vs[k].pause();}catch(e){}}}}

  function pintarEstado(){
    cnt.textContent=(cur+1)+' / '+items.length;
    var ae=document.activeElement;bp.disabled=cur<=0;bn.disabled=cur>=items.length-1;
    /* si la flecha que tenía el foco quedó deshabilitada (primera o última foto), el foco pasa a la otra flecha para no perderse */
    if(ae&&ae.disabled&&(ae===bp||ae===bn)){var otro=ae===bn?bp:bn;try{(otro.disabled?bx:otro).focus({preventScroll:true});}catch(e){}}
    var uno=items.length<2;bp.parentNode.hidden=uno;bn.parentNode.hidden=uno;
    var it=items[cur]||{};ayuda.hidden=usoZoom||it.t!=='i';
    cargar(cur);cargar(cur+1);cargar(cur-1);pausar(cur);
    var ch=track.children;for(var k=0;k<ch.length;k++){if(k!==cur&&ch[k].classList.contains('z'))desZoom(ch[k]);}
  }

  function leer(){raf=0;var w=track.clientWidth||1;var i=Math.round(track.scrollLeft/w);if(i<0)i=0;if(i>items.length-1)i=items.length-1;if(i!==cur){cur=i;pintarEstado();}}

  function ir(i,suave){
    if(i<0||i>items.length-1)return;cur=i;
    var x=i*track.clientWidth;
    if(suave&&!reduce&&track.scrollTo){track.scrollTo({left:x,behavior:'smooth'});}else{track.scrollLeft=x;}
    pintarEstado();
  }

  function zoom(im,e){
    var li=im.parentNode;if(!li)return;
    if(li.classList.contains('z')){desZoom(li);return;}
    var r=im.getBoundingClientRect();if(!r.width||!r.height)return;
    var fx=(e.clientX-r.left)/r.width,fy=(e.clientY-r.top)/r.height;
    var W=r.width*2,H=r.height*2;
    li.classList.add('z');
    if(im.getAttribute('srcset'))im.setAttribute('sizes',Math.round(W)+'px');
    im.style.width=W+'px';im.style.height=H+'px';
    var cw=li.clientWidth,chh=li.clientHeight;
    im.style.margin=(H<chh?Math.round((chh-H)/2):0)+'px '+(W<cw?Math.round((cw-W)/2):0)+'px';
    li.scrollLeft=Math.max(0,fx*W-cw/2);li.scrollTop=Math.max(0,fy*H-chh/2);
    ayuda.hidden=true;usoZoom=true;
  }
  function desZoom(li){li.classList.remove('z');var im=li.querySelector('img');if(im){im.style.width='';im.style.height='';im.style.margin='';if(im.getAttribute('srcset'))im.setAttribute('sizes','100vw');}li.scrollLeft=0;li.scrollTop=0;}

  function enfocables(){var l=box.querySelectorAll('button:not([disabled]),video,iframe,[tabindex]:not([tabindex="-1"])'),o=[];for(var k=0;k<l.length;k++){var e=l[k];if(e.offsetParent!==null||e===document.activeElement)o.push(e);}return o;}

  function tecla(e){
    if(!abierta)return;var k=e.key;
    if(k==='Escape'||k==='Esc'){e.preventDefault();cerrar();return;}
    if(k==='ArrowRight'){e.preventDefault();ir(cur+1,true);return;}
    if(k==='ArrowLeft'){e.preventDefault();ir(cur-1,true);return;}
    if(k==='Home'){e.preventDefault();ir(0,true);return;}
    if(k==='End'){e.preventDefault();ir(items.length-1,true);return;}
    if(k==='Tab'){var f=enfocables();if(!f.length){e.preventDefault();return;}var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&(document.activeElement===a||!box.contains(document.activeElement))){e.preventDefault();z.focus();}
      else if(!e.shiftKey&&(document.activeElement===z||!box.contains(document.activeElement))){e.preventDefault();a.focus();}}
  }
  /* Si el foco se escapa (clic fuera de los botones, lector de pantalla), vuelve a la lupa */
  function retener(e){if(abierta&&box&&!box.contains(e.target)){try{bx.focus({preventScroll:true});}catch(err){}}}

  function abrir(lista,i,o){
    if(!lista||!lista.length)return;o=o||{};
    if(!box)build();
    items=lista;cur=Math.max(0,Math.min(lista.length-1,i|0));
    ret=o.returnFocus||document.activeElement;
    var h1=document.querySelector('.lmp .info h1');var nom=(h1&&h1.textContent||'').replace(/\s+/g,' ').trim();
    ttl.textContent=nom;box.setAttribute('aria-label',nom?('Fotos de '+nom):'Fotos del producto');
    pintar();
    prevOv=document.documentElement.style.overflow;prevOvB=document.body.style.overflow;
    document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';
    box.hidden=false;abierta=true;
    track.scrollLeft=cur*track.clientWidth;
    pintarEstado();
    try{bx.focus({preventScroll:true});}catch(err){bx.focus();}
    document.addEventListener('focusin',retener);document.addEventListener('keydown',tecla,true);
    try{if(window.history&&history.pushState){history.pushState({lmlupa:1},'');estado=true;}}catch(err){estado=false;}
    try{if(typeof window.lmTrack==='function'){var m=location.pathname.match(/\/products\/([^?#\/]+)/);window.lmTrack('lm_ficha_lupa',{origen:o.origen||'',foto:cur+1,total:items.length,handle:m?m[1]:''});}}catch(err){}
  }

  function cerrar(desdeHistoria){
    if(!abierta)return;
    if(!desdeHistoria&&estado){estado=false;try{history.back();}catch(err){}}
    abierta=false;pausar(-1);
    var ch=track.children;for(var k=0;k<ch.length;k++){if(ch[k].classList.contains('z'))desZoom(ch[k]);}
    box.hidden=true;
    document.removeEventListener('focusin',retener);document.removeEventListener('keydown',tecla,true);
    document.documentElement.style.overflow=prevOv;document.body.style.overflow=prevOvB;
    if(ret&&ret.focus){try{ret.focus({preventScroll:true});}catch(err){ret.focus();}}
  }

  window.LMLupa={open:abrir,close:function(){cerrar();}};
})();
